export default "__VITE_ASSET__DJxlRDyI__"